import api from "./api";

export const getTrustEngineV2Dashboard = async () => {
    const response = await api.get("/TrustEngineV2/dashboard");
    return response.data;
};